if ("function" != typeof PickupAvailabilityCompact) {
  class e extends HTMLElement {
    constructor() {
      super(), this.classList.add("active");
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this), this.fetchAvailability(this.dataset.variantId));
        }).bind(this),
        { rootMargin: "0px 0px 50px 0px" }
      ).observe(this),
        (this.storeSelector = document.querySelector(
          "store-selector[data-main-selector]"
        )),
        window.addEventListener("load", () => {
          this.storeSelector &&
            this.storeSelector.addEventListener("storechanged", (e) => {
              this.fetchAvailability(this.dataset.variantId);
            });
        });
    }
    fetchAvailability(e) {
      const t = `${
        this.dataset.baseUrl.endsWith("/")
          ? this.dataset.baseUrl
          : `${this.dataset.baseUrl}/`
      }variants/${e}/?section_id=helper-pickup-availability-compact`;
      fetch(t)
        .then((e) => e.text())
        .then((e) => {
          const t = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(".shopify-section");
          this.renderPreview(t);
        })
        .catch((e) => {
          console.log(e);
        });
    }
    renderPreview(e) {
      const t = localStorage.getItem("selected-store");
      if (this.storeSelector && t && this.storeSelector.storesList[t]) {
        let i = !1;
        t &&
          e.querySelectorAll(".pickup-availability-alert").forEach((e) => {
            t == e.dataset.store &&
              ((this.innerHTML = e.innerHTML.replace(
                "{{ store }}",
                this.storeSelector.storesList[t]
              )),
              (i = !0));
          }),
          i ||
            ((this.innerHTML = e
              .querySelector(
                ".pickup-availability-alert[data-default-unavailable]"
              )
              .innerHTML.replace(
                "{{ store }}",
                this.storeSelector.storesList[t]
              )),
            (i = !0)),
          (t && i) || (this.innerHTML = "");
      } else
        this.innerHTML = e.querySelector(
          ".pickup-availability-alert[data-default-store]"
        ).innerHTML;
    }
  }
  void 0 === customElements.get("pickup-availability-compact") &&
    customElements.define("pickup-availability-compact", e);
}
if ("function" != typeof PickupAvailabilityExtended) {
  class e extends HTMLElement {
    constructor() {
      super(),
        this.classList.add("active"),
        this.fetchAvailability(this.dataset.variantId);
    }
    fetchAvailability(e) {
      const t = `${
        this.dataset.baseUrl.endsWith("/")
          ? this.dataset.baseUrl
          : `${this.dataset.baseUrl}/`
      }variants/${e}/?section_id=helper-pickup-availability-extended`;
      fetch(t)
        .then((e) => e.text())
        .then((e) => {
          const t = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(".shopify-section");
          this.renderPreview(t);
        })
        .catch((e) => {
          console.log(e);
        });
    }
    renderPreview(e) {
      const t = e.querySelector("#PickupAvailabilityWidget");
      t
        ? ((this.innerHTML = t.innerHTML),
          this.querySelectorAll(
            ".pickup-availability-widget__location-view"
          ).forEach((e) => {
            e.addEventListener("click", () => {
              document
                .getElementById(`${e.getAttribute("aria-controls")}`)
                .classList.toggle("opened"),
                e.setAttribute(
                  "aria-selected",
                  "true" == e.getAttribute("aria-selected") ? "false" : "true"
                );
            });
          }))
        : console.log("error in availablity fetch");
      const i = e.querySelector("#PickupAvailabilitySidebar");
      i &&
        (document.querySelector("sidebar-drawer#site-availability-sidebar") &&
          document
            .querySelector("sidebar-drawer#site-availability-sidebar")
            .remove(),
        document.body.appendChild(
          i.querySelector("#site-availability-sidebar")
        ),
        document
          .querySelector(".pickup-availability-widget__more")
          .addEventListener("click", (e) => {
            e.preventDefault(),
              document.getElementById("site-availability-sidebar").show();
          }));
    }
  }
  void 0 === customElements.get("pickup-availability-extended") &&
    customElements.define("pickup-availability-extended", e);
}
